import { useState, useCallback } from 'react';
import classnames from "classnames";
import { DataTrack } from '../Utilities';

/**  returns a dynamic component which wraps the children in a link (a)
all such links will receive href, track props, and a conditional shared 'hover' className
used for sharing a link/hover status without imposing any requirements on the html structure
e.g. you have an image next to a column-div

USAGE

const ProfileLink = sharedLink({
  href: profileURL(contractor.mas_dealer_code, locale?.code),
  track: ['learn-more', {
    'element-location': 'main section text link',
    'destination': 'Contractor Profile',
    ...contractorDataTrack(contractor)
  }]
});

return (<>
  <ProfileLink>
    <img  src={contractor.logo} alt={contractor.store_name} />
  </ProfileLink>
  <div className="info">
    <ProfileLink>
      <h6>{contractor.store_name}</h6>
    </ProfileLink>
    ...
  </div>
  </>
*/
function sharedLink({ href, track }) {
    const [hovered, setHovered] = useState(false);
    const onEnter = () => setHovered(true);
    const onLeave = () => setHovered(false);
    return ({ children, ...props }) => <DataTrack {...track[1]} track={track[0]}>
        <a
            href={href}
            {...props}
            className={classnames({ hover: hovered }, props.className)}
            onMouseOver={onEnter}
            onMouseLeave={onLeave}
        >
            {children}
        </a>
    </DataTrack>
}

export default sharedLink;
